import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	create (status) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/user/atwork', {
				status: status
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response.body)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/user/atwork.js